import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import ExpenseCategoriesManager from './ExpenseCategoriesManager';

/** Muhasebe menüsünden açılan Gider Türleri sayfası (Kasa ve Kâr-Zarar'daki modal ile aynı liste). */
const ExpenseCategoriesPage: React.FC = () => (
  <Box sx={{ p: { xs: 1, md: 3 }, maxWidth: 960 }}>
    <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>Gider Türleri</Typography>
    <Paper sx={{ p: 2 }}>
      <ExpenseCategoriesManager />
    </Paper>
  </Box>
);

export default ExpenseCategoriesPage;
